import React, { Component, Fragment } from "react";
import { connect } from 'react-redux'
import { currentWidget, setRegPage } from '../../action/action'
import { setGoHome, setShowRoomDoor, setLoader, setLoginRequired } from '../../layout2.0/action/homeAction'
import { HashRouter, Link } from 'react-router-dom';
import DoorKeyPopup from './doorKeyPopup';
import { setShowDoorKeyPopup } from '../../layout2.0/action/action';
import $ from 'jquery'
import MobileKeyOverlay from './mobileKeyOverlay';
import {
    setDoorKeyNotificaionPage, popupOpenClose,
    setDeviceLoginPage, setDoorKeyValidationPopUp,
    SetCallNativeMethods, setQRScannerPage
} from '../../action/action'
import {
    gettingKeyFailMsg, gettingKeySuccMsg, tapToUnlockMsg,
    gettingKeyMsg, successfulUnlock, tapToUnlockMsgTenSec,
    gettingKeySuccMsgTenSec, CMSPath, CLICKED, EXIT, DEMO, assaAbloyErrorCodes,
    CMSPath_HTTP,
    CMSPath_HTTPS
} from '../../config/constant'
import {withTranslation} from "react-i18next";
import runRequestPermission from '../../layout2.0/JS/runRequestPermission'
import {DEBUG, dormakabaErrorCodes} from '../../config/constant';
import DoorKeySlider from './doorKeySlider'
import { sendAnalytics } from "../../action/homeAction"
import { calculateTimeDifference, getDefaultAnalyticsLabel,clearSharedPref } from "../../layout2.0/JS/utility";
import SuccessFailScreen from "../../layout2.0/UI/SuccessFailScreen";
import { checkIsBluetoothEnabledForDoorKey } from "./helper";

window.callFromNative = (key, error) => {
    try {
        console.log("callFromNative being called");
        window.compRef.displayMessage(key, error);
    } catch (e) {
        console.log("Error while trying to call js function from Native:", e);
        if(window.FireBasePlugin){
            // window.FirebasePlugin.logMessage("error messege");
            window.FirebasePlugin.logError("Dormakaba: error while tring to call js function callFromNative() from Native:" + e)
          }
    }
}

window.runAfterPermissionsCheck = (key) => {
    try {
        console.log("runAfterPermissionCheck being called");
        window.compRef.permissionCallback(key, window.compRef);
    }catch (e) {
        console.log("error while tring to call runAfterPermissionCheck from Native:", e);
        if(window.FireBasePlugin){
            // window.FirebasePlugin.logMessage("error messege");
            window.FirebasePlugin.logError("error while tring to call runAfterPermissionCheck from Native:" + e)
          }
    }
};

class RoomDoor extends Component{

    constructor(props){
        super(props);
        this.state = {
            room: localStorage.getItem('room'),
            sliderLeft:0,
            doorUnlocked:false,
            showOverlay:false,
            overlayComp: null,
            overlayMsg:null,
            tryAgainCase: null,
            showRoomDoorPage: false,
            showLocationErrScreen: false,
            singleUserReqRequest:false,
            showBlankOverlay:true,
            showSlider: false,
            widgetLaunchTime: new Date,
            initialTimeToGetKey: new Date,
            keyAlreadyRecieved: true,
            requiredCMSPath: CMSPath_HTTPS.slice(8),
            fileActivated: false,
            showTimeout: false,
            widgetName: localStorage.getItem("digitalKeyWidgetName"),
            showDoorUnlockTimeout: false,
            isEndpointSetup: "false",
            titleMsg: "",
            showBluetoothErrScreen: false
        }
        window.compRef = this;
        this.timeOutClear = 0;
        this.noOfAttemptsTimeout = 0;
        this.noOfAttemptsRegisterDevice = 0;
        this.noOfAttemptsUnlockFailed = 0;
        this.noOfAttemptsRequestTimeout = 0;
        this.noOfAttemptsKeyReceive = 0;
        this.errorInIOSLocation = true
        this.keyReceived = false
        this.downloadingDoorKeyEventSent = false
        this.deployingDoorKeyEventSent = false
        this.currentAPICAllCase = 0
    }

    sendGAEvent = (action, message, callback, extraLabelInfo, pageName, isGetDoorKeyError) => {
        let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        let errorDetail = ""
        if(isGetDoorKeyError){
            switch(this.currentAPICAllCase){
                case 0: errorDetail = "Step: 1 Device Registration - API: Fetch invitation code"; break;
                case 5: errorDetail = "Step: 3 Deploying your Door Key"; break;
                case 7: errorDetail = "Step: 2 Downloading your Door Key - API: Get Mobile Key"; break;
                default: break;
            }
        }
        this.props.sendAnalytics(
            this.props.guestDetail, 
            "Digital Door Key", 
            action, 
            {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget",  "pageName": pageName, "errorMessage": message && message, ...extraLabelInfo, "errorDetail": errorDetail, "widgetSessionId": localStorage.getItem("doorKeySessionToken")},
            0, 
            this.props.guestIsLoggedIn,
            callback ? callback : false
        ); 
    }

    nativeCalls = (SessionToken,reserNO,roomNo) => {
        console.log("nativeCalls");
        // let reserNO = localStorage.getItem("reservationNo");
        let door_key_type = localStorage.getItem("door_key_type");
        const FCMToken = localStorage.getItem("FCM_token");

        this.setState({initialTimeToGetKey: new Date})
        try {
            if(window.device){
                if (window.device.platform == "Android") {

                    let doorKeyTypeWindow = null;

                    if(door_key_type == "AA"){
                        if(window.assaabloy) doorKeyTypeWindow = window.assaabloy;
                    }

                    if(door_key_type == "DK"){
                        if(window.dormakaba) doorKeyTypeWindow = window.dormakaba;
                    }

                    if(door_key_type == "SALTO"){
                        if(window.salto) doorKeyTypeWindow = window.salto
                    }

                    if(doorKeyTypeWindow){
                        if (doorKeyTypeWindow.isEndpointSetupComplete()) {
                            this.props.SetCallNativeMethods(false);
                            console.log("isEndpointSetupComplete() success");
                            if (doorKeyTypeWindow.getNumberOfMobileKeys() != 0) {
                                console.log("getNumberOfMobileKeys() success and openLock() called")
                                console.log("tapToUnlockMsg");
                                this.setState({showOverlay:false, showSlider:true})
                            } else {
                                this.setState({keyAlreadyRecieved:false})
                                console.log("getNumberOfMobileKeys() failed and getMobileKey() called");
                                console.log("reservationNo", reserNO);
                                doorKeyTypeWindow.getMobileKey(`${this.state.requiredCMSPath}`, SessionToken, reserNO, this.state.isEndpointSetup)
                                console.log("getNumberOfMobileKeys() failed gettingKeyMsg")
                                this.setState({showOverlay:true,overlayComp:"attention"})
                            }
                        } else {
                            this.setState({keyAlreadyRecieved:false})
                            console.log("isEndpointSetupComplete() failed");
                            console.log("reservationNo", reserNO);
                            if (reserNO) {
                                this.sendGAEvent("DOOR KEY REQUEST", "", null, {"noOfAttempts": this.noOfAttemptsRegisterDevice + 1}, "DOOR KEY REQUEST")
                                this.noOfAttemptsRegisterDevice = this.noOfAttemptsRegisterDevice + 1
                                if(!this.state.singleUserReqRequest){
                                    doorKeyTypeWindow.userRegistration(`${this.state.requiredCMSPath}`, SessionToken, reserNO, roomNo, FCMToken);
                                    console.log("isEndpointSetupComplete() failed gettingKeyMsg");
                                    this.setState({singleUserReqRequest: true});  
                                    this.setState({showOverlay:true,overlayComp:"attention"})
                                }
                                // this.setState({ message: gettingKeyMsg });
                            }else{
                                if(window.FireBasePlugin){
                                    // window.FirebasePlugin.logMessage("error messege");
                                    window.FirebasePlugin.logError("Dormakaba: isEndpointSetupComplete() failed")
                                }
                                this.setState({showOverlay:true,overlayComp:"error", overlayMsg: "isEndpointSetupComplete() failed",tryAgainCase: null});
                            }
                        }
                    }

                } else {
                    if(door_key_type == "AA"){
                        if (window.cordova && window.cordova.plugins && window.cordova.plugins.AssaAbloy) {
                            window.cordova.plugins.AssaAbloy.isEndpointSetupComplete("hello", this.isEndPointSucc, this.isEndPointFail)
                        }
                    } 
                      
                    if(door_key_type == "DK"){
                        if (window.cordova && window.cordova.plugins && window.cordova.plugins.Dormakaba) {
                            window.cordova.plugins.Dormakaba.isEndpointSetupComplete("hello", this.isEndPointSucc, this.isEndPointFail)
                        }
                    }

                    if(door_key_type == "SALTO"){
                        if (window.cordova && window.cordova.plugins && window.cordova.plugins.Salto) {
                            window.cordova.plugins.Salto.isEndpointSetupComplete("hello", this.isEndPointSucc, this.isEndPointFail)
                        }
                    }
                }
            } else {
                console.log("this is not a android or iOS device");
            }
        } catch (err) {
            console.log("error while checking digital key", err)
            this.setState({showOverlay:true,overlayComp:"error", overlayMsg: "error while checking digital key",tryAgainCase: null});
            if(window.FireBasePlugin){
                // window.FirebasePlugin.logMessage("error messege");
                window.FirebasePlugin.logError("error while checking digital key:" + err)
              }
        }
    }

    isEndPointFail = () => {
        this.setState({ showOverlay: true, overlayComp: "attention", keyAlreadyRecieved: false})

        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
       // localStorage.setItem("reservationNo", '505931333');

        let reserNO = localStorage.getItem("Set_Current_Logged_In_Guest_Details") ? JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))[0].reservationNumber : null;
        let room = localStorage.getItem("room");

        console.log("isEndpointSetupComplete() failed");
        console.log("reservationNo", reserNO);
        console.log("roomNumber", room);

        let door_key_type = localStorage.getItem("door_key_type");
        const FCMToken = localStorage.getItem("FCM_token");
 

        try{
            if (reserNO) {
                this.sendGAEvent("DOOR KEY REQUEST", "", null, {"noOfAttempts": this.noOfAttemptsRegisterDevice + 1}, "DOOR KEY REQUEST")
                this.noOfAttemptsRegisterDevice = this.noOfAttemptsRegisterDevice + 1
                console.log('calling user registration with values', SessionToken, reserNO, room, `${this.state.requiredCMSPath}`)

                if(door_key_type == "AA"){
                    window.cordova.plugins.AssaAbloy.userRegistration(
                        { connectorIp: `${this.state.requiredCMSPath}`, sessionToken: SessionToken, reservationNumber: reserNO, roomNumber: room, fcmToken: FCMToken },
                        () => { console.log("userRegistration success")
                           this.setState({ showOverlay: true, overlayComp: "attention" })
        
                           window.cordova.plugins.AssaAbloy.getNumberOfMobileKeys("hello",
                               this.onGetMobileKeySucc,
                               this.onGetMobileKeyFaill
                           )
                        },
                        () => { console.log("userRegistration failed") }
                    )
                } 
                  
                if(door_key_type == "DK"){
                    window.cordova.plugins.Dormakaba.userRegistration(
                        { connectorIp: `${this.state.requiredCMSPath}`, sessionToken: SessionToken, reservationNumber: reserNO, roomNumber: room },
                        () => { console.log("userRegistration success")
                           this.setState({ showOverlay: true, overlayComp: "attention" })
        
                           window.cordova.plugins.Dormakaba.getNumberOfMobileKeys("hello",
                               this.onGetMobileKeySucc,
                               this.onGetMobileKeyFaill
                           )
                        },
                        () => { console.log("userRegistration failed") }
                    )
                }

                if(door_key_type == "SALTO"){
                    window.cordova.plugins.Salto.userRegistration(
                        { connectorIp: `${this.state.requiredCMSPath}`, sessionToken: SessionToken, reservationNumber: reserNO, roomNumber: room },
                        () => { console.log("userRegistration success")
                           this.setState({ showOverlay: true, overlayComp: "attention" })
        
                           window.cordova.plugins.Salto.getNumberOfMobileKeys("hello",
                               this.onGetMobileKeySucc,
                               this.onGetMobileKeyFaill
                           )
                        },
                        () => { console.log("userRegistration failed") }
                    )
                }
            }
        } catch (error) {
            console.log('error in userRegistration AssaAbloy', error)
            if(DEBUG){
                alert('--Error in UserRegistration',error)
            }
        }
    }
    
    isEndPointSucc = () => {

        let door_key_type = localStorage.getItem("door_key_type");

        this.props.SetCallNativeMethods(false);
        this.setState({ showOverlay: true, overlayComp: "attention", isEndpointSetup: "true" })
        console.log("isEndpointSetupComplete() success");

        if(door_key_type == "AA"){
            window.cordova.plugins.AssaAbloy.getNumberOfMobileKeys("hello",
                this.onGetMobileKeySucc,
                this.onGetMobileKeyFaill
            )
        } 
          
        if(door_key_type == "DK"){
            window.cordova.plugins.Dormakaba.getNumberOfMobileKeys("hello",
                this.onGetMobileKeySucc,
                this.onGetMobileKeyFaill
            )
        }

        if(door_key_type == "SALTO"){
            window.cordova.plugins.Salto.getNumberOfMobileKeys("hello",
                this.onGetMobileKeySucc,
                this.onGetMobileKeyFaill
            )
        }
    }
    
    onGetMobileKeyFaill = () => {

        let door_key_type = localStorage.getItem("door_key_type");

        this.setState({keyAlreadyRecieved:false})
        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        let reserNO = localStorage.getItem("Set_Current_Logged_In_Guest_Details") ? JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))[0].reservationNumber : null;
        console.log("getNumberOfMobileKeys() failed and getMobileKey() called");
        console.log("reservationNo", reserNO);


        if(door_key_type == "AA"){
            window.cordova.plugins.AssaAbloy.getMobileKey(
                { connectorIp: `${this.state.requiredCMSPath}`, sessionToken: SessionToken, reservationNumber: reserNO, isEndpointSetup: this.state.isEndpointSetup },
                () => { console.log("getMobileKey success")},
                () => { console.log("getMobileKey failed") }
            )
        } 
          
        if(door_key_type == "DK"){
            window.cordova.plugins.Dormakaba.getMobileKey(
                { connectorIp: `${this.state.requiredCMSPath}`, sessionToken: SessionToken, reservationNumber: reserNO, isEndpointSetup: this.state.isEndpointSetup },
                () => { console.log("getMobileKey success")},
                () => { console.log("getMobileKey failed") }
            )
        }

        if(door_key_type == "SALTO"){
            window.cordova.plugins.Salto.getMobileKey(
                { connectorIp: `${this.state.requiredCMSPath}`, sessionToken: SessionToken, reservationNumber: reserNO, isEndpointSetup: this.state.isEndpointSetup },
                () => { console.log("getMobileKey success")},
                () => { console.log("getMobileKey failed") }
            )
        }

        console.log("gettingKeyMsg")
        this.setState({ message: gettingKeyMsg });
    }
    
    onGetMobileKeySucc = () => {
        this.setState({showOverlay:false, showSlider:true})
        console.log("getNumberOfMobileKeys() success and openLock() called")
        console.log("tapToUnlockMsg");
        this.setState({ message: tapToUnlockMsg });
        localStorage.setItem("doorKeyFlag", true);
        console.log("--- Open Lock");
        // window.cordova.plugins.AssaAbloy.activateFile(); // commented this after abhijeet's suggestion, in the milind's project it was uncommented.
    }

    activateFileHandler = () => {

        let door_key_type = localStorage.getItem("door_key_type");
        console.log("activateFile method called.")
        try{
            console.log("activateFile method called.")
            this.sendGAEvent("DOOR UNLOCK ATTEMPT", "", () => {}, {}, "DOOR KEY SLIDER")
            if (window.device && window.device.platform == "Android") {
                console.log("activateFile method android")

                let doorKeyTypeWindow = null;
                let timeAfterWhichDeactivateFile = 20000;

                if(door_key_type == "AA"){
                    if(window.assaabloy) doorKeyTypeWindow = window.assaabloy;
                }

                if(door_key_type == "DK"){
                    if(window.dormakaba) doorKeyTypeWindow = window.dormakaba;
                }

                if(door_key_type == "SALTO"){
                    if(window.salto) {
                        doorKeyTypeWindow = window.salto;
                    }
                }

                if(doorKeyTypeWindow){
                doorKeyTypeWindow.activateFile(DEMO);
                this.setState({fileActivated: true, showTimeout: true})
                this.timeOutClear = window.setTimeout(() => {
                    // this.setState({showOverlay:true,overlayComp:"error", overlayMsg: tapToUnlockMsgTenSec,tryAgainCase: "onKeySuccess"});
                    this.setState({ sliderLeft: 0, doorUnlocked: false });
                    this.setState({fileActivated: false})
                    doorKeyTypeWindow.deActivateFile();
                    if(!this.state.showOverlay && this.state.showTimeout) {
                        this.setState({showDoorUnlockTimeout: true})
                        this.sendGAEvent("DOOR UNLOCK ATTEMPT - TIMEOUT", "Door unlock timeout. Please tap the phone on the lock when key is enabled", () => {}, {"noOfAttempts": this.noOfAttemptsTimeout + 1, displayError: this.props.t("doorKey_event_error_messages.SDK_DOOR_UNLOCK_TIMEOUT"), errorCode: 'SDK_DOOR_UNLOCK_TIMEOUT'}, "DOOR KEY SLIDER")
                        this.noOfAttemptsTimeout = this.noOfAttemptsTimeout + 1
                    }
                }, timeAfterWhichDeactivateFile );
                }
            } else {
            
                if(door_key_type == "AA"){
                if (window.cordova && window.cordova.plugins && window.cordova.plugins.AssaAbloy){
                console.log("activateFile method from iOS called")
                window.cordova.plugins.AssaAbloy.activateFile(DEMO);
                this.setState({fileActivated: true, showTimeout: true})
                    this.timeOutClear = window.setTimeout(() => {
                        // this.setState({showOverlay:true,overlayComp:"error", overlayMsg: tapToUnlockMsgTenSec,tryAgainCase: "onKeySuccess"});
                        this.setState({ sliderLeft: 0, doorUnlocked: false});
                        window.cordova.plugins.AssaAbloy.deActivateFile();
                        this.setState({fileActivated: false})
                        if(!this.state.showOverlay && this.state.showTimeout) {
                            this.setState({showDoorUnlockTimeout: true})
                            this.sendGAEvent("DOOR UNLOCK ATTEMPT - TIMEOUT", "Door unlock timeout. Please tap the phone on the lock when key is enabled", () => {}, {"noOfAttempts": this.noOfAttemptsTimeout + 1, displayError: this.props.t("doorKey_event_error_messages.SDK_DOOR_UNLOCK_TIMEOUT"), errorCode: 'SDK_DOOR_UNLOCK_TIMEOUT'}, "DOOR KEY SLIDER")
                            this.noOfAttemptsTimeout = this.noOfAttemptsTimeout + 1
                        }
                    }, 20000);
                }}

                if(door_key_type == "DK"){
                if (window.cordova && window.cordova.plugins && window.cordova.plugins.Dormakaba){
                    console.log("activateFile method from iOS called")
                    window.cordova.plugins.Dormakaba.activateFile(DEMO);
                    this.setState({fileActivated: true, showTimeout: true})
                        this.timeOutClear = window.setTimeout(() => {
                            // this.setState({showOverlay:true,overlayComp:"error", overlayMsg: tapToUnlockMsgTenSec,tryAgainCase: "onKeySuccess"});
                            this.setState({ sliderLeft: 0, doorUnlocked: false});
                            window.cordova.plugins.Dormakaba.deActivateFile();
                            this.setState({fileActivated: false})
                            if(!this.state.showOverlay && this.state.showTimeout) {
                                this.setState({showDoorUnlockTimeout: true})
                                this.sendGAEvent("DOOR UNLOCK ATTEMPT - TIMEOUT", "Door unlock timeout. Please tap the phone on the lock when key is enabled", () => {}, {"noOfAttempts": this.noOfAttemptsTimeout + 1, displayError: this.props.t("doorKey_event_error_messages.SDK_DOOR_UNLOCK_TIMEOUT"), errorCode: 'SDK_DOOR_UNLOCK_TIMEOUT'}, "DOOR KEY SLIDER")
                                this.noOfAttemptsTimeout = this.noOfAttemptsTimeout + 1
                            }
                        }, 20000);
                }}

                if(door_key_type == "SALTO"){
                    if (window.cordova && window.cordova.plugins && window.cordova.plugins.Salto){
                        console.log("activateFile method from iOS called")
                        window.cordova.plugins.Salto.activateFile(DEMO);
                        this.setState({fileActivated: true, showTimeout: true})
                            this.timeOutClear = window.setTimeout(() => {
                                // this.setState({showOverlay:true,overlayComp:"error", overlayMsg: tapToUnlockMsgTenSec,tryAgainCase: "onKeySuccess"});
                                this.setState({ sliderLeft: 0, doorUnlocked: false});
                                window.cordova.plugins.Salto.deActivateFile();
                                this.setState({fileActivated: false})
                                if(!this.state.showOverlay && this.state.showTimeout) {
                                    this.setState({showDoorUnlockTimeout: true})
                                    this.sendGAEvent("DOOR UNLOCK ATTEMPT - TIMEOUT", "Door unlock timeout. Please tap the phone on the lock when key is enabled", () => {}, {"noOfAttempts": this.noOfAttemptsTimeout + 1, displayError: this.props.t("doorKey_event_error_messages.SDK_DOOR_UNLOCK_TIMEOUT"), errorCode: 'SDK_DOOR_UNLOCK_TIMEOUT'}, "DOOR KEY SLIDER")
                                    this.noOfAttemptsTimeout = this.noOfAttemptsTimeout + 1
                                }
                            }, 20000);
                    }
                }
            }
        }catch(e){
            console.log("Error while activating door key",e);
            this.setState({sliderLeft:0, doorUnlocked:false});
            this.setState({showOverlay:true,overlayComp:"error", overlayMsg: "Error while activating door key",tryAgainCase: null}); 
            if(window.FireBasePlugin){
                // window.FirebasePlugin.logMessage("error messege");
                window.FirebasePlugin.logError("Error while activating door key:" + e)
              }
        }
    }

    deActivateFileHandler = () => {
        let door_key_type = localStorage.getItem("door_key_type");

        if (window.device && window.device.platform == "Android") {
            this.setState({ sliderLeft: 0, doorUnlocked: false, fileActivated: false });

            if(door_key_type == "AA"){
                if(window.assaabloy)  window.assaabloy.deActivateFile();
            }

            if(door_key_type == "DK"){
                if(window.dormakaba)  window.dormakaba.deActivateFile();
            }

            if(door_key_type == "SALTO"){
                if(window.salto)  window.salto.deActivateFile();
            }
        } else {

            if(door_key_type == "AA"){
                if (window.cordova && window.cordova.plugins && window.cordova.plugins.AssaAbloy) {
                    this.setState({ sliderLeft: 0, doorUnlocked: false, fileActivated: false});
                    window.cordova.plugins.AssaAbloy.deActivateFile();
                }
            } 
              
            if(door_key_type == "DK"){
                if (window.cordova && window.cordova.plugins && window.cordova.plugins.Dormakaba) {
                    this.setState({ sliderLeft: 0, doorUnlocked: false, fileActivated: false});
                    window.cordova.plugins.Dormakaba.deActivateFile();
                }
            }

            if(door_key_type == "SALTO"){
                if (window.cordova && window.cordova.plugins && window.cordova.plugins.Salto) {
                    this.setState({ sliderLeft: 0, doorUnlocked: false, fileActivated: false});
                    window.cordova.plugins.Salto.deActivateFile();
                }
            }
        }
    }

    setupSliderEventHandler = () => {

        const self = this;

        if($("#slider-unlock")[0]){
        $('#slider-unlock')[0].addEventListener('touchmove', function(event) {

            if(self.state.sliderLeft >= 230){
                return;
            }

            event.preventDefault();
            const el = event.target;
            const touch = event.touches[0];
            let curX = touch.pageX - this.offsetLeft - 60;
            if(curX <= 0) return;
            if(curX > 230){
                // $('well').style.opacity = 0;
                // alert("activated");
                self.setState({doorUnlocked:true})
                if(window.screen.width > 360){
                    self.setState({sliderLeft: 235})
                }else {
                    self.setState({sliderLeft: 230})
                }
                self.activateFileHandler();
                return;
            }
                self.setState({sliderLeft: curX})
            //    el.style.left = curX + 'px';
        }, false);
        
        $('#slider-unlock')[0].addEventListener('touchend', function(event) {

            if(self.state.sliderLeft >= 200){
                return;
            }

            this.style.webkitTransition = '-webkit-transform 0.3s ease-in';
            this.addEventListener( 'webkitTransitionEnd', function( event ) { this.style.webkitTransition = 'none'; }, false );
            self.setState({sliderLeft: 0})
        }, false);
    }}

    handleActivateDoorKeyFileHanlder = () => {
        const isBluetoothEnabled = checkIsBluetoothEnabledForDoorKey();
        if (isBluetoothEnabled) {
            this.setState({ doorUnlocked: true })
            this.activateFileHandler();
        } else {
            this.setState({ showBluetoothErrScreen: true });
            this.setState({ sliderLeft: 0, doorUnlocked: false });
        }
    }

    displayMessage = (key, error) => {
        console.log("Key - error", key, error)

        const sessionToken = localStorage.getItem('GuestJourneySessionToken');
        let reservationNo = localStorage.getItem("Set_Current_Logged_In_Guest_Details") ? JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))[0].reservationNumber : null;
        let room = localStorage.getItem("room");
        
        switch (key) {
            case 0:
                console.log("displayMessage case 0");
                this.setState({showOverlay:true,overlayComp:"error", overlayMsg: error || gettingKeyFailMsg,tryAgainCase: null, titleMsg: ""});
                // this.setState({ message: gettingKeyFailMsg, tryAgain: true, tryAgainCase: "GetKeyFail" });
                this.sendGAEvent("DOOR KEY REQUEST - FAILED", error || gettingKeyFailMsg, () => {}, {"noOfAttempts": this.noOfAttemptsKeyReceive + 1, displayError: this.props.t("doorKey_event_error_messages.SDK_DOOR_KEY_REQUEST_FAILED"), errorCode: 'SDK_DOOR_KEY_REQUEST_FAILED' }, "DOOR KEY REQUEST", true)
                this.noOfAttemptsKeyReceive = this.noOfAttemptsKeyReceive + 1
                this.downloadingDoorKeyEventSent = false;
                this.deployingDoorKeyEventSent = false;
                break;
            case 1:
                console.log("displayMessage case 1");
                this.setState({showOverlay:false, showSlider:true, titleMsg: ""})
                // const dk_validate_key_received_event_sent = localStorage.getItem("dk_validate_key_received_event_sent")
                // if(!dk_validate_key_received_event_sent)
                let finalTimeToGetKey = new Date
                let durationToGetKey = calculateTimeDifference(this.state.initialTimeToGetKey, finalTimeToGetKey, 'second');
                if(!this.keyReceived) {
                    this.keyReceived = true
                    this.sendGAEvent("DOOR KEY REQUEST - SUCCESS", "", () => {}, {"durationToGetKey": durationToGetKey}, "DOOR KEY REQUEST")
                }
                this.downloadingDoorKeyEventSent = false;
                this.deployingDoorKeyEventSent = false;

                // setTimeout(() => {localStorage.removeItem("dk_validate_key_received_event_sent")}, 2000)
                /*this.setState({ message: gettingKeySuccMsg });
                this.timeOutClear = window.setTimeout(() => {
                    window.android.stopScan();
                    this.setState({ message: gettingKeySuccMsgTenSec, tryAgain: true, tryAgainCase: "onKeySuccess" });
                }, 10000);*/
                break;
            case 2:
                console.log("displayMessage case 2");
                this.setState({showOverlay:true, showSlider: false, overlayComp:"success",overlayMsg:successfulUnlock, titleMsg: ""})
                this.sendGAEvent("DOOR UNLOCK ATTEMPT - SUCCESS", "", null, {}, "DOOR KEY SLIDER")
                this.downloadingDoorKeyEventSent = false;
                this.deployingDoorKeyEventSent = false;
                // window.clearTimeout(this.timeOutClear);
                /*this.setState({
                    //  message: successfulUnlock,
                    tryAgain: false
                });
                window.android.stopScan();*/
                break;
            case 3:
                console.log("displayMessage case 3");
                if(localStorage.getItem("door_key_type") == "DK"){
                    this.setState({showOverlay:true, showSlider: false, overlayComp:"error", overlayMsg: `${this.props.t('door_key.door_unlock_failed')}`,tryAgainCase: null, titleMsg: "Door unlock timeout", showTimeout: false});
                    this.sendGAEvent("DOOR UNLOCK ATTEMPT - FAILED", "Error code - " + error + " Error message - " + dormakabaErrorCodes[`error_${error}`], () => {}, {"noOfAttempts": this.noOfAttemptsUnlockFailed + 1, displayError: `${error || this.props.t("doorKey_event_error_messages.SDK_DOOR_UNLOCK_FAILED")}`, errorCode: 'SDK_DOOR_UNLOCK_FAILED'}, "DOOR KEY SLIDER")
                } else if(localStorage.getItem("door_key_type") == "AA"){
                    this.setState({showOverlay:true, showSlider: false, overlayComp:"error", overlayMsg: `${this.props.t('door_key.door_unlock_failed')}`,tryAgainCase: null, titleMsg: "Door unlock timeout", showTimeout: false});
                    this.sendGAEvent("DOOR UNLOCK ATTEMPT - FAILED", "Error code - " + error + " Error message - " + assaAbloyErrorCodes[`${error}`], () => {}, {"noOfAttempts": this.noOfAttemptsUnlockFailed + 1, displayError: `${error || this.props.t("doorKey_event_error_messages.SDK_DOOR_UNLOCK_FAILED")}`, errorCode: 'SDK_DOOR_UNLOCK_FAILED'}, "DOOR KEY SLIDER")
                } else {
                    this.setState({showOverlay:true, showSlider: false, overlayComp:"error", overlayMsg: `${this.props.t('door_key.door_unlock_failed')}`,tryAgainCase: null, titleMsg: "Door unlock timeout", showTimeout: false});
                    this.sendGAEvent("DOOR UNLOCK ATTEMPT - FAILED", "Error code - " + error + " Error message - " + error, () => {}, {"noOfAttempts": this.noOfAttemptsUnlockFailed + 1, displayError: `${error || this.props.t("doorKey_event_error_messages.SDK_DOOR_UNLOCK_FAILED")}`, errorCode: 'SDK_DOOR_UNLOCK_FAILED'}, "DOOR KEY SLIDER")
                }
                this.noOfAttemptsUnlockFailed = this.noOfAttemptsUnlockFailed + 1
                this.downloadingDoorKeyEventSent = false;
                this.deployingDoorKeyEventSent = false;
                window.clearTimeout(this.timeOutClear);
                this.deActivateFileHandler()
                break;

            case 4:
                console.log("displayMessage case 4");
                this.setState({showOverlay:true,  showSlider: false,overlayComp:"error", overlayMsg: "Room number doesn't match with the room number in the key file",tryAgainCase: null, titleMsg: ""});
                this.sendGAEvent("DOOR UNLOCK ATTEMPT - FAILED", "Room number doesn't match with the room number in the key file", () => {}, {"noOfAttempts": this.noOfAttemptsUnlockFailed + 1, displayError: this.props.t("doorKey_event_error_messages.SDK_DOOR_UNLOCK_ROOM_MISMATCH"), errorCode: 'SDK_DOOR_UNLOCK_ROOM_MISMATCH'}, "DOOR KEY SLIDER")
                this.noOfAttemptsUnlockFailed = this.noOfAttemptsUnlockFailed + 1
                this.downloadingDoorKeyEventSent = false;
                this.deployingDoorKeyEventSent = false;
                window.clearTimeout(this.timeOutClear);
                this.deActivateFileHandler()
                break;
            
            case 5:
                console.log("displayMessage case 5");
                this.setState({showOverlay:true,  showSlider: false,overlayComp:"attention", overlayMsg: "Deploying your Door Key", titleMsg: ""});
                this.currentAPICAllCase = 5;
                
                // if(!this.deployingDoorKeyEventSent) {
                //     this.deployingDoorKeyEventSent = true;
                //     this.sendGAEvent("DEPLOYING YOUR DOOR KEY", "", () => {}, {}, "DOOR KEY REQUEST")
                // }
                break;
            case 6:
                console.log("displayMessage case 6");
                this.setState({showOverlay:true,  showSlider: false,overlayComp:"error", titleMsg: "Door key request timeout", overlayMsg: "It is taking longer than usual to get the key, please check your internet connection and make sure your location is enabled and try again.", tryAgainCase: null});
                this.downloadingDoorKeyEventSent = false;
                this.deployingDoorKeyEventSent = false;
                this.currentAPICAllCase = 6;
                this.sendGAEvent("DOOR KEY REQUEST - TIMEOUT", "Key state remains active and not changing to deployed", () => {}, {"noOfAttempts": this.noOfAttemptsRequestTimeout + 1, displayError: this.props.t("doorKey_event_error_messages.SDK_DOOR_KEY_REQUEST_TIMEOUT"), errorCode: 'SDK_DOOR_KEY_REQUEST_TIMEOUT'}, "DOOR KEY REQUEST", true)
                this.noOfAttemptsRequestTimeout = this.noOfAttemptsRequestTimeout + 1
                break;
            case 7:
                console.log("displayMessage case 7");
                this.setState({showOverlay:true,  showSlider: false,overlayComp:"attention", overlayMsg: "Downloading your Door Key", titleMsg: ""});
                this.currentAPICAllCase = 7;
                // if(!this.downloadingDoorKeyEventSent) {
                //     this.downloadingDoorKeyEventSent = true;
                //     this.sendGAEvent("DOOR KEY REQUEST", "", () => {}, {}, "DOOR KEY REQUEST")
                // }
                break;
            case 8:
                console.log("displayMessage case 4");
                this.setState({showOverlay:true,  showSlider: false,overlayComp:"error", overlayMsg: "Reservation number doesn't match with the reservation number in the key file",tryAgainCase: null, titleMsg: ""});
                this.sendGAEvent("DOOR UNLOCK ATTEMPT - FAILED", "Reservation number doesn't match with the reservation number in the key file", () => {}, {"noOfAttempts": this.noOfAttemptsUnlockFailed + 1, displayError: this.props.t("doorKey_event_error_messages.SDK_DOOR_UNLOCK_RESERVATION_MISMATCH"), errorCode: 'SDK_DOOR_UNLOCK_RESERVATION_MISMATCH' }, "DOOR KEY SLIDER")
                this.noOfAttemptsUnlockFailed = this.noOfAttemptsUnlockFailed + 1
                this.downloadingDoorKeyEventSent = false;
                this.deployingDoorKeyEventSent = false;
                window.clearTimeout(this.timeOutClear);
                this.deActivateFileHandler()
                break;
            case 11:
                this.nativeCalls(sessionToken,reservationNo,room);
                break;
            default:
            console.log("no case match.");
        }
    }

    initializeComponent = () => {
        if (this.props.currentWidget) {
            setTimeout(() => {
                this.props.currentWidget({ widgetType: true });
            }, 10);
        }
        // this.requestLocationPermission();
        console.log('Room Door mounted')

        localStorage.setItem("doorKeyPage", "DOOR KEY REQUEST")

        // console.log("locationPopupShown",locationPopupShown)

        localStorage.setItem("locationPopupShown", "true")
        this.setState({ showLocationErrScreen: false, showBlankOverlay: false });

        const sessionToken = localStorage.getItem('GuestJourneySessionToken');
        let reservationNo = localStorage.getItem("Set_Current_Logged_In_Guest_Details") ? JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))[0].reservationNumber : null;
        let room = localStorage.getItem("room");

        if (!reservationNo || reservationNo === "null") {
            if (process.env.REACT_APP_INROOMTAB == "true") {
                this.props.setLoginRequired(true)
            } else {
                this.props.setRegPage(true);
            }
        } else {
            this.nativeCalls(sessionToken, reservationNo, room);
            console.log("componentDidMount gettingKeyMsg")
        }

        $("#room_door_back").attr("style", "color:#fff !important;");
    }

    componentWillUnmount(){
        this.props.currentWidget({});
        window.clearTimeout(this.timeOutClear);

        // Send Analytics

        let widgetCloseTime = new Date
        let duration = calculateTimeDifference(this.state.widgetLaunchTime, widgetCloseTime, 'second');

        let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        this.props.sendAnalytics(
            this.props.guestDetail, 
            "Digital Door Key", 
            EXIT, 
            {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "duration": duration, "widgetSessionId": localStorage.getItem("doorKeySessionToken"), "pageName": localStorage.getItem("doorKeyPage")},
            0, 
            this.props.guestIsLoggedIn
        );
        //
    }

    componentDidUpdate() {
        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        if (this.props.runNativeCalls) {
            this.props.SetCallNativeMethods(false);
            // this.setState({ message: gettingKeyMsg, firstTimeRefresh: true });
            this.nativeCalls(SessionToken);
            console.log("componentDidUpdate gettingKeyMsg");
        }
    }

    componentDidMount() {
        this.initializeComponent();
    }
    
    close = () => {
        let door_key_type = localStorage.getItem("door_key_type");

        if(this.state.fileActivated){
            if (window.device && window.device.platform == "Android") {

                if(door_key_type == "AA"){
                    if(window.assaabloy)  window.assaabloy.deActivateFile();
                }

                if(door_key_type == "DK"){
                    if(window.dormakaba)  window.dormakaba.deActivateFile();
                }

                if(door_key_type == "SALTO"){
                    if(window.salto)  window.salto.deActivateFile();
                }
            } else {

                if(door_key_type == "AA"){
                    if (window.cordova && window.cordova.plugins && window.cordova.plugins.AssaAbloy) {
                        window.cordova.plugins.AssaAbloy.deActivateFile();
                    }
                } 
                
                if(door_key_type == "DK"){
                    if (window.cordova && window.cordova.plugins && window.cordova.plugins.Dormakaba) {
                        window.cordova.plugins.Dormakaba.deActivateFile();
                    }
                }

                if(door_key_type == "SALTO"){
                    if (window.cordova && window.cordova.plugins && window.cordova.plugins.Salto) {
                        window.cordova.plugins.Salto.deActivateFile();
                    }
                }
            }
        }
        this.props.setGoHome(true)
        this.props.setDoorKeyNotificaionPage(false);
        this.props.setDoorKeyValidationPopUp(false);
        this.props.setQRScannerPage(false);
        this.setState({showOverlay:false})
    }

    tryAgainClick = () => {

        let door_key_type = localStorage.getItem("door_key_type");

        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        let reservationNo = localStorage.getItem("Set_Current_Logged_In_Guest_Details") ? JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))[0].reservationNumber : null;
        let room = localStorage.getItem("room");
        this.currentAPICAllCase = 0

        if(window.device){
            if (window.device.platform == "Android") {

                if(door_key_type == "AA"){
                    if(window.assaabloy && window.assaabloy.registerSdkListeners)  window.assaabloy.registerSdkListeners();
                }

                if(door_key_type == "DK"){
                    if(window.dormakaba && window.dormakaba.registerSdkListeners)  window.dormakaba.registerSdkListeners();
                }

                if(door_key_type == "SALTO"){
                    if(window.salto && window.salto.registerSdkListeners)  window.salto.registerSdkListeners();
                }
            } else {

                if(door_key_type == "AA"){
                    if (window.cordova && window.cordova.plugins && window.cordova.plugins.AssaAbloy && window.cordova.plugins.AssaAbloy.registerSdkListeners) {
                        window.cordova.plugins.AssaAbloy.registerSdkListeners();
                    }
                } 
                
                if(door_key_type == "DK"){
                    if (window.cordova && window.cordova.plugins && window.cordova.plugins.Dormakaba && window.cordova.plugins.Dormakaba.registerSdkListeners) {
                        window.cordova.plugins.Dormakaba.registerSdkListeners();
                    }
                }

                if(door_key_type == "SALTO"){
                    if (window.cordova && window.cordova.plugins && window.cordova.plugins.Salto && window.cordova.plugins.Salto.registerSdkListeners) {
                        window.cordova.plugins.Salto.registerSdkListeners();
                    }
                }
            }
        }
        if (this.state.tryAgainCase === "onKeySuccess") {
            this.nativeCalls(SessionToken, reservationNo, room);
        }else{
            this.setState({showOverlay:true,overlayComp:"attention",overlayMsg:null})

            // clearSharedPref( () => this.nativeCalls(SessionToken, reservationNo, room))
            this.nativeCalls(SessionToken, reservationNo, room)
        }
    }

    resetParentState = () => {
        this.setState({
            room: localStorage.getItem('room'),
            sliderLeft:0,
            doorUnlocked:false,
            showOverlay:false,
            overlayComp: null,
            overlayMsg:null,
            tryAgainCase: null,
            showRoomDoorPage: false,
            showLocationErrScreen: false,
            singleUserReqRequest:false,
            showBlankOverlay:true,
            showSlider: false,
            widgetLaunchTime: new Date,
            initialTimeToGetKey: new Date,
            keyAlreadyRecieved: true,
            requiredCMSPath: CMSPath_HTTPS.slice(8),
            fileActivated: false,
            showTimeout: false,
            widgetName: localStorage.getItem("digitalKeyWidgetName"),
            showDoorUnlockTimeout: false,
            isEndpointSetup: "false",
            titleMsg: ""
        })
        this.initializeComponent();
    };

    render(){
        const { t } = this.props
        return(
            <div className="main-container background-overlay" style = {{minHeight:"100vh"}}>
                {this.state.showBlankOverlay && <MobileKeyOverlay overlay="blank"/>}
                
                {!this.state.showLocationErrScreen && this.state.showOverlay && 
                <MobileKeyOverlay 
                    overlay = {this.state.overlayComp} 
                    message = {this.state.overlayMsg}
                    titleMsg={this.state.titleMsg}
                    tryAgain = {this.tryAgainClick} 
                    close = {this.close} 
                    widgetName = {this.state.widgetName}
                    errorClose = {this.close}/>}
                
                {this.state.showLocationErrScreen && 
                <MobileKeyOverlay 
                    overlay="error" 
                    locationErr={true} 
                    message={"We are unable to retrieve your location. Please Enable location permission for the app from the phone's Settings."}
                    titleMsg={t('door_key.location_access_err')}
                    errorClose = {this.close}
                    hideTryAgain={true}/>}

                {this.state.showBluetoothErrScreen && 
                <MobileKeyOverlay 
                    overlay="error" 
                    message={t('door_key.bluetooth_disabled_message')}
                    titleMsg={t('door_key.bluetooth_disabled_err')}
                    errorClose = {() => this.setState({showBluetoothErrScreen: false})}
                    hideTryAgain={true}/>}

                {
                    this.state.showSlider && 
                    <DoorKeySlider 
                        activateFileHandler={this.activateFileHandler}
                        setupSliderEventHandler={this.setupSliderEventHandler}
                        handleActivateDoorKeyFileHanlder={this.handleActivateDoorKeyFileHanlder}
                        doorUnlocked={this.state.doorUnlocked}
                        sliderLeft={this.state.sliderLeft}
                        keyAlreadyRecieved={this.state.keyAlreadyRecieved}
                        widgetLaunchTime={this.state.widgetLaunchTime}
                        close={this.close}
                        resetParentState={this.resetParentState}
                        />
                }
                {
                    this.state.showDoorUnlockTimeout &&
                        <MobileKeyOverlay 
                        overlay="timeout" 
                        locationErr={false} 
                        message={t('door_key.door_unlock_failed')}
                        titleMsg={"Door unlock timeout"}
                        errorClose={() => this.setState({showDoorUnlockTimeout: false})}
                        hideTryAgain={true}/>
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        menuColor: state.store.home.MenuColor,
        showDoorKeyPopup:state.store2.showDoorKeyPopup,
        guestDetail: state.store.home.guestDetails,
        reservationNo: state.store.reservationNo,
        runNativeCalls: state.store.doorKey.runNativeCalls,
        CheckedInGuest: state.store.CheckedInGuest,
        installedAppName: state.store.installedAppName,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        loginGuestDetails: state.store2.loginGuestDetails,
    }
}

export default connect(mapStateToProps,{
    currentWidget,
    setShowDoorKeyPopup,
    setDoorKeyNotificaionPage,
    popupOpenClose,
    setLoginRequired,
    setDeviceLoginPage,
    setDoorKeyValidationPopUp,
    SetCallNativeMethods,
    setRegPage,
    setShowRoomDoor,
    setGoHome,
    setQRScannerPage,
    sendAnalytics,
    setLoader
})(withTranslation('translations')(RoomDoor));    
